import { styled } from '@mui/material/styles'
import { Box } from '@mui/material'
import { DataGrid, gridClasses } from '@mui/x-data-grid'

export const StyledBoxContainerTitle = styled(Box)(({ theme }) => ({
  borderBottom: '2px solid',
  borderColor: theme.palette.primary.main,
}))

export const StyledBoxContainerContent = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  justifyContent: 'space-between',
  flexWrap: 'wrap',
  padding: '1rem',
  width: '100%',
  backgroundColor: theme.palette.grey[100],
  color: theme.palette.text.primary,
}))

export const StyledCardProcessHearing = styled(Box)(({ theme }) => ({
  padding: '1rem',
  width: '100%',
  color: theme.palette.text.primary,
  borderRadius: '0.5rem',
  border: '1px solid',
  borderColor: theme.palette.primary.main,
}))

export const StyledCardTitleCategory = styled(Box)(({ theme }) => ({
  display: 'inline-flex',
  padding: '0.35rem 0.5rem 0.35rem 0.5rem',
  backgroundColor: theme.palette.grey[100],
  color: theme.palette.text.primary,
  borderRadius: '0.3rem',
  borderBottom: '4px solid',
  marginRight: '0.75rem',
}))

export const StyledCardStatus = styled(Box)(({ theme }) => ({
  display: 'inline-flex',
  padding: '0.35rem 1rem 0.35rem 1rem',
  backgroundColor: theme.palette.grey[200],
  color: theme.palette.text.secondary,
  borderRadius: '1rem',
}))

export const DataGridCustom = styled(DataGrid)(({ theme }) => ({
  [`& .${gridClasses.columnHeaders}`]: {
    backgroundColor: theme.palette.info.main,
    color: theme.palette.common.white,
  },
  [`& .${gridClasses.row}`]: {
    backgroundColor: theme.palette.grey['50'],
  },
  [`& .${gridClasses.footerContainer}`]: {
    backgroundColor: theme.palette.grey['50'],
  },
  /*[`& .${gridClasses.checkboxInput}`]: {
    color: theme.palette.primary.main,
  },*/
}))
